module.exports = "<div class=\"loader\">Loading...</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading.component.html
// module id = 883
// module chunks = 1